module.exports = __webpack_public_path__ + "66380b2ed923e7a6debaffa30851ad40.jpg";